let configRouters = [];
const files = require.context('./modules', false, /\.js$/);
files.keys().forEach(key => {
  let routersArr = files(key).default;
  configRouters = configRouters.concat(routersArr);
});

export default [
  {
    path: '*',
    redirect: '/mallHomePage/all'
  },
  {
    path: '',
    redirect: '/mallHomePage/all'
  },
  ...configRouters
];
